import { AlertTriangle, CheckCircle2, Clock3, PackageOpen } from 'lucide-react';

const CONFIG = {
  TO_PREPARE: { label: 'To Prepare', Icon: PackageOpen, cls: 'border-accent bg-accent-subtle text-accent' },
  READY_FOR_HANDOFF: { label: 'Ready for Handoff', Icon: CheckCircle2, cls: 'border-success bg-success-subtle text-success' },
  HANDOFF_IN_PROGRESS: { label: 'Handoff in Progress', Icon: Clock3, cls: 'border-warning bg-warning-subtle text-warning' },
  NEEDS_ATTENTION: { label: 'Needs Attention', Icon: AlertTriangle, cls: 'border-danger bg-danger-subtle text-danger' },
};

export default function FulfillmentGroupBadge({ group, label }) {
  const config = CONFIG[group] || { label: 'Review', Icon: Clock3, cls: 'border-neutral-200 bg-neutral-100 text-neutral-700 dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-300' };
  const Icon = config.Icon;
  return (
    <span className={`inline-flex min-h-7 items-center gap-1.5 rounded-md border px-2 py-1 text-xs font-semibold ${config.cls}`}>
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {label || config.label}
    </span>
  );
}
